import { render, staticRenderFns } from "./ScadaView.vue?vue&type=template&id=f3bc61b2&scoped=true&"
import script from "./ScadaView.vue?vue&type=script&lang=js&"
export * from "./ScadaView.vue?vue&type=script&lang=js&"
import style0 from "./ScadaView.vue?vue&type=style&index=0&id=f3bc61b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bc61b2",
  null
  
)

export default component.exports